import "dayjs/locale/ja";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/types";

const DebitVoucher = () => {
  const { loggedInUser } = useSelector((state: RootState) => state.global);
  return (
    <>
      Debit Voucher Posting
    </>
  );
};

export default DebitVoucher;